import { PROFILE_TAB_KEY } from './constants';
import { AnalyticsTypes } from '../../../middleware/google-analytics';
import { PROFILE_GA_CATEGORY } from '../../constants';
import { EVENT_INITIATORS, INTERACTION_TYPES, TARGETS } from '../../../EventTrackingConstants';

export const ActionTypes = {
    CLICK_PRACTICE_NAME: `${PROFILE_TAB_KEY}/CLICK_PRACTICE_NAME`,
    TRACK_CLICK_PROFESSIONAL_STATEMENT_SHOW_MORE: `${PROFILE_TAB_KEY}/TRACK_CLICK_PROFESSIONAL_STATEMENT_SHOW_MORE`,
    TRACK_CLICK_I_BUBBLE_NPI: `${PROFILE_TAB_KEY}/TRACK_CLICK_I_BUBBLE_NPI`,
    TRACK_CLICK_I_BUBBLE_LANGUAGE: `${PROFILE_TAB_KEY}/TRACK_CLICK_I_BUBBLE_LANGUAGE`,
    TRACK_CLICK_I_BUBBLE_INSURANCE_ACCEPTED: `${PROFILE_TAB_KEY}/TRACK_CLICK_I_BUBBLE_INSURANCE_ACCEPTED`,
    TRACK_CLICK_I_BUBBLE_PRACTICE_NAMES: `${PROFILE_TAB_KEY}/TRACK_CLICK_I_BUBBLE_PRACTICE_NAMES`,
    TRACK_CLICK_I_BUBBLE_SPECIALTY: `${PROFILE_TAB_KEY}/TRACK_CLICK_I_BUBBLE_SPECIALTY`,
    TRACK_CLICK_I_BUBBLE_BOARD_CERTIFICATIONS: `${PROFILE_TAB_KEY}/TRACK_CLICK_I_BUBBLE_BOARD_CERTIFICATIONS`,
    TRACK_CLICK_I_BUBBLE_HOSPITAL_AFFILIATIONS: `${PROFILE_TAB_KEY}/TRACK_CLICK_I_BUBBLE_HOSPITAL_AFFILIATIONS`,
    TRACK_CLICK_I_BUBBLE_PROVIDER_GENDER: `${PROFILE_TAB_KEY}/TRACK_CLICK_I_BUBBLE_PROVIDER_GENDER`,
    TRACK_CLICK_RAPID_REGISTRATION: `${PROFILE_TAB_KEY}/TRACK_CLICK_RAPID_REGISTRATION`,
    TRACK_CLICK_SEE_YOU_AGAIN: `${PROFILE_TAB_KEY}/TRACK_CLICK_SEE_YOU_AGAIN`,
    TRACK_CLICK_SPEEDY_RESPONSE: `${PROFILE_TAB_KEY}/TRACK_CLICK_SPEEDY_RESPONSE`,
    TRACK_CLICK_SCHEDULING_HERO: `${PROFILE_TAB_KEY}/TRACK_CLICK_SCHEDULING_HERO`,
    TRACK_CLICK_DATA_PROVIDED_BY: `${PROFILE_TAB_KEY}/TRACK_CLICK_DATA_PROVIDED_BY`,
};

export const clickPracticeName = practiceName => ({
    type: ActionTypes.CLICK_PRACTICE_NAME,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            action: 'Click Practice Name',
            label: practiceName,
            tags: [],
        },
    },
});

export const trackClickProfessionalStatementShowMore = () => ({
    type: ActionTypes.TRACK_CLICK_PROFESSIONAL_STATEMENT_SHOW_MORE,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            action: 'Click Professional Statement Read More',
            category: PROFILE_GA_CATEGORY,
            data: {
                Section: TARGETS.PROFILE,
                Component: TARGETS.PROFESSIONAL_STATEMENT,
                InteractionType: INTERACTION_TYPES.CLICK,
                Initiator: EVENT_INITIATORS.USER,
                Element: TARGETS.SHOW_MORE,
                EventAction: 'ClickShowMore',
            },
        },
    },
});

export const trackClickDataProvidedBy = () => ({
    type: ActionTypes.TRACK_CLICK_DATA_PROVIDED_BY,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            action: 'Click Data Provided By',
            category: PROFILE_GA_CATEGORY,
            data: {
                Section: TARGETS.PROFILE,
                Component: TARGETS.DATA_PROVIDED_BY,
                InteractionType: INTERACTION_TYPES.CLICK,
                Initiator: EVENT_INITIATORS.USER,
                Element: TARGETS.SHOW_MORE,
                EventAction: 'ClickDataProvidedBy',
            },
        },
    },
});

export const trackClickIBubbleNpi = () => {
    return generateIBubbleTrackingEvent({
        type: ActionTypes.TRACK_CLICK_I_BUBBLE_NPI,
        action: 'Click I Bubble NPI',
        eventAction: 'click npi',
    });
};

export const trackClickIBubbleLanguage = () => {
    return generateIBubbleTrackingEvent({
        type: ActionTypes.TRACK_CLICK_I_BUBBLE_LANGUAGE,
        action: 'Click I Bubble Language',
        eventAction: 'click language',
    });
};

export const trackClickIBubbleInsuranceAccepted = () => {
    return generateIBubbleTrackingEvent({
        type: ActionTypes.TRACK_CLICK_I_BUBBLE_INSURANCE_ACCEPTED,
        action: 'Click I Bubble Insurance Accepted',
        eventAction: 'click insurance accepted',
    });
};

export const trackClickIBubblePracticeNames = () => {
    return generateIBubbleTrackingEvent({
        type: ActionTypes.TRACK_CLICK_I_BUBBLE_PRACTICE_NAMES,
        action: 'Click I Bubble Practice Names',
        eventAction: 'click practice names',
    });
};

export const trackClickIBubbleSpecialty = () => {
    return generateIBubbleTrackingEvent({
        type: ActionTypes.TRACK_CLICK_I_BUBBLE_SPECIALTY,
        action: 'Click I Bubble Specialty',
        eventAction: 'click specialty',
    });
};

export const trackClickIBubbleBoardCertifications = () => {
    return generateIBubbleTrackingEvent({
        type: ActionTypes.TRACK_CLICK_I_BUBBLE_BOARD_CERTIFICATIONS,
        action: 'Click I Bubble Certifications',
        eventAction: 'click certifications',
    });
};

export const trackClickIBubbleHospitalAffiliations = () => {
    return generateIBubbleTrackingEvent({
        type: ActionTypes.TRACK_CLICK_I_BUBBLE_HOSPITAL_AFFILIATIONS,
        action: 'Click I Bubble Hospital Affiliations',
        eventAction: 'click hospital affiliations',
    });
};

export const trackClickIBubbleProviderGender = () => {
    return generateIBubbleTrackingEvent({
        type: ActionTypes.TRACK_CLICK_I_BUBBLE_PROVIDER_GENDER,
        action: 'Click I Bubble Provider Gender',
        eventAction: 'click provider gender',
    });
};

export const trackClickRapidRegistration = () => {
    return generateBadgeTrackingEvent({
        type: ActionTypes.TRACK_CLICK_RAPID_REGISTRATION,
        action: 'Click Rapid Registration',
        eventAction: 'click on rapid registration',
    });
};

export const trackClickSeeYouAgain = () => {
    return generateBadgeTrackingEvent({
        type: ActionTypes.TRACK_CLICK_SEE_YOU_AGAIN,
        action: 'Click See You Again',
        eventAction: 'click on see you again',
    });
};

export const trackClickSpeedyResponse = () => {
    return generateBadgeTrackingEvent({
        type: ActionTypes.TRACK_CLICK_SPEEDY_RESPONSE,
        action: 'Click Speedy Response',
        eventAction: 'click on speedy response',
    });
};

export const trackClickSchedulingHero = () => {
    return generateBadgeTrackingEvent({
        type: ActionTypes.TRACK_CLICK_SCHEDULING_HERO,
        action: 'Click Scheduling Hero',
        eventAction: 'click on scheduling hero',
    });
};

const generateIBubbleTrackingEvent = ({ type, action, eventAction }) => ({
    type,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            action,
            category: PROFILE_GA_CATEGORY,
            data: {
                Section: TARGETS.PROFILE,
                Component: TARGETS.I_BUBBLE,
                InteractionType: INTERACTION_TYPES.CLICK,
                Element: TARGETS.I_BUBBLE,
                Initiator: EVENT_INITIATORS.USER,
                EventAction: eventAction,
            },
        },
    },
});

const generateBadgeTrackingEvent = ({ type, action, eventAction }) => ({
    type,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            action,
            category: PROFILE_GA_CATEGORY,
            data: {
                Section: TARGETS.PROFILE,
                Component: TARGETS.ZOCDOC_RECOGNITION,
                InteractionType: INTERACTION_TYPES.CLICK,
                Element: TARGETS.ZOCDOC_RECOGNITION,
                Initiator: EVENT_INITIATORS.USER,
                EventAction: eventAction,
            },
        },
    },
});
